module.exports = __webpack_public_path__ + "static/media/panel_correo_electronico.c0bc2fcf.svg";